import ContentWrapper from "../../models/content-wrapper/content-wrapper";
import CompanyResourceSummary from "../../models/resource-management/company-resource-summary";
import Credential from "../../models/resource-management/credential";
import CredentialedResource from "../../models/resource-management/credentialed-resource";

/**
 * Maps and returns company resource summaries
 * @param x the incoming payload from the api
 */
function mapCompanyResourceSummaries(
  x: ContentWrapper<CompanyResourceSummary>
): ContentWrapper<CompanyResourceSummary> {
  let c = new ContentWrapper<CompanyResourceSummary>();

  c.totalElements = x.totalElements;
  c.totalPages = x.totalPages;
  c.pageable = x.pageable;
  c.size = x.size;
  c.content = [];

  x.content.forEach((s) => {
    let summary: CompanyResourceSummary = {
      id: s.id,
      externalId: s.externalId,
      qbosId: s.qbosId,
      firstName: s.firstName,
      lastName: s.lastName,
      middleInitial: s.middleInitial,
      credentials: s.credentials,
      displayName: s.displayName,
      createdDatetime: s.createdDatetime,
      npi: s.npi,
      dea: s.dea,
      isSelected: s.isSelected,
      isLoaded: s.isLoaded,
      phoneNumber: s.phoneNumber,
      faxNumber: s.faxNumber,
      trainingCompletionDate: s.trainingCompletionDate,
      status: s.status,
      hasCredentials: s.hasCredentials,
      $provider: null,
      locations: mapLocationsObject(s.locations),
      professionalRelation: s.professionalRelation,
    };
    c.content.push(summary);
  });

  return c;
}

function mapLocationsObject(locations: string): string {
  let objectLocations = JSON.parse(locations);
  if (objectLocations && objectLocations.length)
    return objectLocations.map((l) => l.displayCode).join(", ");
  return "";
}

function mapLicensedClinician(
  clinician: CredentialedResource,
  incoming: CredentialedResource
): void {
  clinician.resourceType = incoming.resourceType;
  clinician.id = incoming.id;
  clinician.firstName = incoming.firstName;
  clinician.lastName = incoming.lastName;
  clinician.preferredName = incoming.preferredName;
  clinician.middleInitial = incoming.middleInitial;
  clinician.resourceStatus = incoming.resourceStatus;
  clinician.emailAddress = incoming.emailAddress;
  clinician.tenantId = incoming.tenantId;
  clinician.addresses = incoming.addresses;
  clinician.phoneNumbers = incoming.phoneNumbers;
  clinician.externalId = incoming.externalId;
  clinician.isEmployee = incoming.isEmployee;

  clinician.credentials = [];
  if (incoming.credentials) {
    for (let i = 0; i < incoming.credentials.length; i++) {
      let y = incoming.credentials[i];
      let c = new Credential();
      c.id = y.id;
      c.type = y.type;
      c.licenseId = y.licenseId;
      c.issueState = y.issueState;
      c.validToDatetime = y.validToDatetime;
      c.validFromDatetime = y.validFromDatetime;
      c.operatingAs = y.operatingAs;
      c.other = y.other;
      c.deleted = y.deleted;
      clinician.credentials.push(c);
    }
  }
}

export { mapLicensedClinician, mapCompanyResourceSummaries };



// WEBPACK FOOTER //
// ./src/mappers/resource-management/licensed-clinician-mapper.ts